const legacyAustralianLocations = [
  // Queensland - Major Cities
  "Brisbane, QLD",
  "Gold Coast, QLD",
  "Cairns, QLD",
  "Townsville, QLD",
  "Toowoomba, QLD",
  "Mount Isa, QLD",
  "Mackay, QLD",
  "Rockhampton, QLD",
  "Bundaberg, QLD",
  "Hervey Bay, QLD",
  "Maryborough, QLD",
  "Gympie, QLD",
  "Noosa, QLD",
  "Sunshine Coast, QLD",
  "Ipswich, QLD",
  "Logan, QLD",
  "Redcliffe, QLD",
  "Caboolture, QLD",
  "Gladstone, QLD",
  "Caloundra, QLD",

  // Queensland - Suburbs & Towns
  "Glenwood, QLD",
  "Curra, QLD",
  "Southport, QLD",
  "Surfers Paradise, QLD",
  "Broadbeach, QLD",
  "Burleigh Heads, QLD",
  "Coolangatta, QLD",
  "Palm Beach, QLD",
  "Mermaid Beach, QLD",
  "Nerang, QLD",
  "Robina, QLD",
  "Currumbin, QLD",
  "Tweed Heads, QLD",
  "Kirra, QLD",
  "Bilinga, QLD",
  "Tugun, QLD",

  // New South Wales - Major Cities
  "Sydney, NSW",
  "Newcastle, NSW",
  "Wollongong, NSW",
  "Central Coast, NSW",
  "Cobar, NSW",
  "Dubbo, NSW",
  "Wagga Wagga, NSW",
  "Albury, NSW",
  "Tamworth, NSW",
  "Armidale, NSW",
  "Coffs Harbour, NSW",
  "Lismore, NSW",
  "Nowra, NSW",
  "Goulburn, NSW",
  "Katoomba, NSW",

  // New South Wales - Suburbs & Towns
  "Glenwood, NSW",
  "Curl Curl, NSW",
  "Currans Hill, NSW",
  "Blacktown, NSW",
  "Parramatta, NSW",
  "Liverpool, NSW",
  "Penrith, NSW",
  "Campbelltown, NSW",
  "Newtown, NSW",
  "Balmain, NSW",
  "Surry Hills, NSW",
  "Paddington, NSW",
  "Cabarita Beach, NSW",
  "Coogee, NSW",
  "Cronulla, NSW",
  "Caringbah, NSW",
  "Carlingford, NSW",

  // Victoria - Major Cities
  "Melbourne, VIC",
  "Geelong, VIC",
  "Ballarat, VIC",
  "Bendigo, VIC",
  "Shepparton, VIC",
  "Latrobe Valley, VIC",
  "Wodonga, VIC",
  "Warrnambool, VIC",
  "Hamilton, VIC",
  "Horsham, VIC",
  "Traralgon, VIC",
  "Mildura, VIC",
  "Warragul, VIC",
  "Swan Hill, VIC",
  "Castlemaine, VIC",

  // Victoria - Suburbs & Towns
  "Glen Waverley, VIC",
  "Glenroy, VIC",
  "Glen Iris, VIC",
  "St Kilda, VIC",
  "Richmond, VIC",
  "South Yarra, VIC",
  "Prahran, VIC",
  "Windsor, VIC",
  "Toorak, VIC",
  "Brighton, VIC",
  "Carlton, VIC",
  "Camberwell, VIC",
  "Carnegie, VIC",
  "Caulfield, VIC",
  "Chadstone, VIC",

  // Western Australia - Major Cities
  "Perth, WA",
  "Mandurah, WA",
  "Bunbury, WA",
  "Geraldton, WA",
  "Kalgoorlie, WA",
  "Karratha, WA",
  "Albany, WA",
  "Broome, WA",
  "Derby, WA",
  "Kununurra, WA",

  // Western Australia - Suburbs & Towns
  "Joondalup, WA",
  "Rockingham, WA",
  "Mandurah, WA",
  "Fremantle, WA",
  "Subiaco, WA",
  "Canning Vale, WA",
  "Carine, WA",
  "Claremont, WA",
  "Como, WA",
  "Cottesloe, WA",

  // South Australia - Major Cities
  "Adelaide, SA",
  "Whyalla, SA",
  "Port Augusta, SA",
  "Port Lincoln, SA",
  "Ceduna, SA",
  "Renmark, SA",
  "Loxton, SA",
  "Kimba, SA",
  "Woomera, SA",
  "Andamooka, SA",

  // South Australia - Suburbs & Towns
  "Glenelg, SA",
  "Prospect, SA",
  "Woodville, SA",
  "Port Adelaide, SA",
  "Henley Beach, SA",
  "Campbelltown, SA",
  "Ceduna, SA",
  "Clare, SA",
  "Cleve, SA",
  "Crystal Brook, SA",

  // Tasmania - Major Cities
  "Hobart, TAS",
  "Launceston, TAS",
  "Devonport, TAS",
  "Burnie, TAS",
  "Ulverstone, TAS",
  "Queenstown, TAS",
  "Scottsdale, TAS",
  "St Helens, TAS",
  "Smithton, TAS",
  "Stanley, TAS",

  // Tasmania - Suburbs & Towns
  "Glenorchy, TAS",
  "New Town, TAS",
  "Sandy Bay, TAS",
  "South Hobart, TAS",
  "West Hobart, TAS",
  "Lenah Valley, TAS",
  "Moonah, TAS",
  "New Norfolk, TAS",
  "Bridgewater, TAS",
  "Grantchester, TAS",

  // Northern Territory - Major Cities
  "Darwin, NT",
  "Palmerston, NT",
  "Alice Springs, NT",
  "Katherine, NT",
  "Tennant Creek, NT",
  "Nhulunbuy, NT",
  "Jabiru, NT",
  "Yulara, NT",
  "Wadeye, NT",
  "Tindal, NT",

  // Northern Territory - Suburbs & Towns
  "Nightcliff, NT",
  "Casuarina, NT",
  "Wagaman, NT",
  "Moil, NT",
  "Nakara, NT",
  "Tiwi, NT",
  "Wulagi, NT",
  "Anula, NT",
  "Malak, NT",
  "Marrara, NT",

  // Australian Capital Territory
  "Canberra, ACT",
  "Belconnen, ACT",
  "Civic, ACT",
  "Gungahlin, ACT",
  "Tuggeranong, ACT",
  "Woden, ACT",
  "Queanbeyan, ACT",
  "Yass, ACT",
  "Murrumbateman, ACT",
  "Hall, ACT",
];

// Active rollout: Fraser Coast council towns only
const fraserCoastLocations = [
  "Aldershot, QLD",
  "Aramara, QLD",
  "Bauple, QLD",
  "Booral, QLD",
  "Burrum Heads, QLD",
  "Brooweena, QLD",
  "Craignish, QLD",
  "Dundowran Beach, QLD",
  "Elliot, QLD",
  "Eurong, QLD",
  "Gundiah, QLD",
  "Glenwood, QLD",
  "Gunalda, QLD",
  "Happy Valley, QLD",
  "Hervey Bay, QLD",
  "Howard, QLD",
  "Maaroom, QLD",
  "Maryborough, QLD",
  "Owanyilla, QLD",
  "Boonooroo, QLD",
  "Poona, QLD",
  "River Heads, QLD",
  "Tawan, QLD",
  "Tiaro, QLD",
  "Tinana, QLD",
  "Tinnanbar, QLD",
  "Toogoom, QLD",
  "Torbanlea, QLD",
  "Tuan, QLD",
];

const locationCatalog = {
  active: fraserCoastLocations,
  legacy: legacyAustralianLocations,
};

const australianLocations = locationCatalog.active;

export { legacyAustralianLocations, fraserCoastLocations, locationCatalog, australianLocations };
